// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".discount-input label[data-v-2b1addcb]{color:#4d64ff}.discount-input label[data-v-2b1addcb]:before{content:\"+ \";font-size:1.5rem;vertical-align:middle}.discount-input[data-isopen=true] label[data-v-2b1addcb]:before{content:\"- \";font-size:1.5rem;vertical-align:middle}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
